module.exports = __webpack_public_path__ + "static/img/ic_no_network.4ed2463f.png";